module.exports = __webpack_public_path__ + "static/live-46dc674f2f01082c4a222c5404a9b886.png";